module.exports = __webpack_public_path__ + "static/img/email-icon.ab595596.svg";